// extracted by mini-css-extract-plugin
export var heading = "destination-module--heading--10125";
export var headingMargin = "destination-module--headingMargin--f9b39";
export var logo = "destination-module--logo--b295a";
export var thingsToDoSection = "destination-module--thingsToDoSection--023f7";
export var topHotels = "destination-module--topHotels--cf21c";